import { Banner, Button } from '@rtkwlf/fenrir-react';
import { useTranslation } from 'react-i18next';

import { ControlledCountryAutocomplete } from '@packages/components/controls/controlled-country-autocomplete/controlled-country-autocomplete';
import { Stack } from '@packages/fenrir/components';

import type { AlertFormInstanceProps } from '../alert-form-instance-props';
import { RuleDuration } from '../rule-duration/rule-duration';

import { useApprovedLoginLocationsForm } from './use-approved-login-locations-form/use-approved-login-locations-form';

export const ApprovedLoginLocationsForm = ({
  defaultValues,
  onSubmit,
  isSubmitting,
  buttonLabels,
  notice,
  alert,
}: AlertFormInstanceProps) => {
  const { t } = useTranslation('components');

  const { control, reset, formState, handleSubmit, isDuplicate } =
    useApprovedLoginLocationsForm({
      defaultValues,
      onSubmit,
      alert,
    });

  return (
    <form onSubmit={handleSubmit}>
      <Stack spacing={2}>
        <ControlledCountryAutocomplete
          control={control}
          required
          label={t('alertConfigurationRules.country')}
          name="country"
          multiple={false}
        />
        <RuleDuration control={control} name="duration" />

        {notice}

        {isDuplicate && (
          <Banner
            appearance="danger"
            title={t('alertConfigurationRules.duplicateEntryBanner.title')}
            description={t(
              'alertConfigurationRules.duplicateEntryBanner.description.approvedLoginLocations',
            )}
          />
        )}
        <Stack direction="row" width="100%" justifyContent="end" spacing={3}>
          <Button
            type="reset"
            variant="link"
            onClick={() => reset()}
            isDisabled={!formState.isDirty || isSubmitting}
          >
            {buttonLabels?.reset ?? t('ui:resetAll')}
          </Button>
          <Button
            type="submit"
            isLoading={isSubmitting}
            isDisabled={!formState.isValid || !formState.isDirty || isDuplicate}
          >
            {buttonLabels?.submit ?? t('ui:apply')}
          </Button>
        </Stack>
      </Stack>
    </form>
  );
};
